import React, { createContext, useContext, useState } from 'react';

const DateTimeContext = createContext();

export const useDateTimeContext = () => {
  const context = useContext(DateTimeContext);
  if (!context) {
    return { activePicker: null, setActivePicker: () => {} };
  }
  return context;
};

export const DateTimeProvider = ({ children }) => {
  const [activePicker, setActivePicker] = useState(null);

  return (
    <DateTimeContext.Provider value={{ activePicker, setActivePicker }}>
      {children}
    </DateTimeContext.Provider>
  );
};

